/**
 * Formats a condition operator + threshold into a human-readable string.
 * Used in Tips sub-tab (0-100 scale).
 */
export function fmtCond(op: string, thr: number, thrMax: number | null): string {
  if (op === 'between' && thrMax !== null) return `${thr}–${thrMax}%`;
  if (op === '>=') return `≥${thr}%`;
  if (op === '<=') return `≤${thr}%`;
  if (op === '>') return `>${thr}%`;
  return `<${thr}%`;
}

/**
 * Formats an action score range (1.0–4.0 scale) into a human-readable string.
 * Used in Actions sub-tab.
 */
export function fmtActionRange(min: number, max: number): string {
  return `${min} – ${max}`;
}
